// Chilean Peso formatter: $ 1.500.000
export function fmtCLP(amount, { showSign = false, dim = false } = {}) {
  if (amount == null || isNaN(amount)) return "—";
  const n = Math.round(Number(amount));
  const abs = Math.abs(n).toLocaleString("es-CL");
  const sign = n < 0 ? "-" : showSign && n > 0 ? "+" : "";
  return `${sign}$ ${abs}`;
}

export function fmtNum(amount) {
  if (amount == null || isNaN(amount)) return "—";
  return Math.round(Number(amount)).toLocaleString("es-CL");
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso);
    return d.toLocaleDateString("es-CL", { year: "numeric", month: "2-digit", day: "2-digit" });
  } catch {
    return iso;
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
